import { ABP, eLayoutType } from '@abp/ng.core';

export const FLEET_SCORE_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/fleet-score',
    iconClass: 'fas fa-medal',
    name: '::Menu:FleetScore',
    layout: eLayoutType.application,
    order: 6,
    requiredPolicy: 'cargo_fleet.FleetScore',
  },
];
